"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var maskAutoCompleteRecipient_1 = require("../services/maskAutoCompleteRecipient");
var deleteFromCache_1 = require("owa-recipient-cache/lib/selectors/deleteFromCache");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('maskRecipientFromFindControl')(function maskRecipientFromFindControl(recipientWell, recipientToMask) {
    // Remove Recipient from Find Control and Cache.
    recipientWell.findResultSet = recipientWell.findResultSet.filter(function (curObj) {
        return curObj !== recipientToMask;
    });
    deleteFromCache_1.default(recipientToMask.EmailAddress);
    // Mask Recipient Well
    maskAutoCompleteRecipient_1.maskAutoCompleteRecipient(recipientToMask.EmailAddress.EmailAddress);
});
//# sourceMappingURL=maskRecipientFromFindControl.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/maskRecipientFromFindControl.js
// module id = 3180
// module chunks = 2 3